// js
AOS.init();

$(document).ready(function() {

	$('input[type="button"], .btn-pergunta').click(function(){
		$(this).removeClass('disabled').addClass('selected').siblings('input, div').addClass('disabled').removeClass('selected');
		if ($(this).parent().hasClass('invalid') || $(this).parent().parent().hasClass('invalid')) {
			$(this).parent().removeClass('invalid');
			$(this).parent().parent().removeClass('invalid');
		}
	});
$('input').keyup(function(){
	$(this).parent().parent().removeClass('invalid');
});


$('.next').on('click', function (e) {
  let isValid = true;

  const nameInput = $('#name');
  const idadeInput = $('input[name=idade]');
  const sexoInput = $('input[name=sexo]');
  const perguntaContainer = $('.pergunta');

  const validateField = (input, key) => {
    if (!input.length) return;

    const selected = input.filter('.selected');
    const value = input.is('#name') ? input.val() : selected.val();

    if (value) {
      localStorage.setItem(key, value);
    } else {
      isValid = false;

      if (input.is('#name')) {
        input.parent().parent().addClass('invalid');
      } else {
        input.parent().addClass('invalid');
      }
    }
  };

  const validatePergunta = (container) => {
    if (!container.length) return;

    const key = container.data('key'); // ex: pergunta1
    const selected = container.find('.btn-pergunta.selected');
    const value = selected.data('value');

    if (value) {
      localStorage.setItem(key, value);
    } else {
      isValid = false;
      container.parent().addClass('invalid');
    }
  };

  // campos padrão
  validateField(nameInput, 'name');
  validateField(idadeInput, 'idade');
  validateField(sexoInput, 'sexo');

  validatePergunta(perguntaContainer);

  if (!isValid) e.preventDefault();
});

// ---- RESULTADO CALCULATION (runs only on resultado.php) ----
if ($('.resultado-block').length) {

  // Allow forcing a result via ?item=1|2|3 (for preview/testing)
  const urlParams = new URLSearchParams(window.location.search);
  const forcedItem = urlParams.get('item');
  if (forcedItem && ['1','2','3','4'].includes(forcedItem)) {
    $('#resultado-' + forcedItem).addClass('active');
    $('.nombre-usuario').text(localStorage.getItem('name') || '');
  } else {

  // Scores per answer: [da_comp, da_sobre, curcuma, ultra375]
  const SCORES = {
    idade: {
      '<29':   [2, 2, 0, 0],
      '30-45': [3, 3, 1, 0],
      '46-65': [1, 1, 3, 0],
      '>65':   [0, 0, 2, 3]
    },
    sexo: {
      'Hombre':                [2, 2, 0, 2],
      'Mujer':                 [2, 2, 2, 0],
      'Prefiero no responder': [1, 1, 1, 1]
    },
    pergunta1: {
      'Siento molestias musculares y/o articulares en el cuerpo con frecuencia':         [0, 0, 3, 0],
      'Me siento cansado/a, sin energía en el día a día':                                [2, 0, 0, 3],
      'Soy activo/a y quiero un apoyo para recuperarme después del esfuerzo físico':     [2, 2, 0, 0],
      'Me siento generalmente bien, pero quiero prevenir y sentirme mejor a largo plazo':[0, 0, 0, 3]
    },
    pergunta2: {
      'Sí':                               [0, 0, 3, 0],
      'No':                               [0, 0, 0, 0],
      'Prefiero no responder / No lo sé': [0, 0, 0, 0]
    },
    pergunta3: {
      'Activo, con deporte o esfuerzo físico frecuente':     [2, 2, 0, 0],
      'Intenso, con poco tiempo para mí':                    [2, 2, 1, 0],
      'Más tranquilo, pero quiero cuidarme mejor que antes': [0, 0, 2, 2],
      'Variable, depende del día':                           [1, 1, 1, 1]
    },
    pergunta4: {
      'Sí, casi a diario':                      [2, 2, 0, 0],
      'Sí, de 2 a 4 días a la semana':          [2, 1, 1, 0],
      'A veces':                                [0, 0, 1, 2],
      'No, llevo una vida bastante sedentaria': [0, 0, 2, 1]
    },
    pergunta5: {
      'Sí, tomo varios medicamentos de forma regular': [0, 0, 0, 3],
      'Sí, tomo 1 medicamento de forma regular':       [0, 0, 0, 1],
      'Sí, tomo algún medicamento de forma puntual':   [0, 0, 0, 0],
      'No, no tomo medicación habitualmente':          [0, 0, 0, 0]
    },
    pergunta6: {
      'Me cuesta dormir o no descanso bien':            [0, 0, 2, 1],
      'Duermo bien, pero aun así me siento cansado/a': [0, 0, 2, 2],
      'Duermo bien y me recupero correctamente':        [1, 1, 0, 0],
      'Depende mucho del momento':                      [0, 0, 1, 1]
    },
    pergunta7: {
      'Mi rendimiento y recuperación':     [3, 3, 0, 0],
      'Mi bienestar muscular y articular': [0, 0, 3, 0],
      'Mi energía diaria':                 [0, 0, 0, 3],
      'Sentirme mejor de forma general':   [0, 0, 1, 2]
    },
    pergunta8: {
      'Comprimidos fáciles de tomar, en formato individual':          [3, 0, 1, 1],
      'Algo práctico, que pueda tomar en cualquier momento sin agua': [0, 4, 0, 0],
      'Me adapto a cualquier formato':                                [1, 1, 1, 1],
      'Busco la máxima comodidad en el uso diario':                   [0, 3, 0, 1]
    },
    pergunta9: {
      'Una sola toma al día':                [1, 1, 1, 1],
      'Más de una toma varias veces al día': [0, 0, 0, 0]
    }
  };

  // Accumulate totals
  const totals = [0, 0, 0, 0];
  Object.keys(SCORES).forEach(function(key) {
    const answer = localStorage.getItem(key);
    if (answer && SCORES[key][answer]) {
      SCORES[key][answer].forEach(function(pts, i) { totals[i] += pts; });
    }
  });

  // Override rules (priority: Q2 > Q5)
  let resultId;
  const q2 = localStorage.getItem('pergunta2');
  const q5 = localStorage.getItem('pergunta5');

  if (q2 === 'Sí') {
    resultId = 'resultado-4'; // Force Cúrcuma + B6
  } else if (q5 === 'Sí, tomo varios medicamentos de forma regular') {
    resultId = 'resultado-1'; // Force Ultra 375
  } else {
    // Winner by highest score
    // Index: 0=da_comp → resultado-3, 1=da_sobre → resultado-2, 2=curcuma → resultado-4, 3=ultra → resultado-1
    const resultMap = ['resultado-3', 'resultado-2', 'resultado-4', 'resultado-1'];
    const maxScore = Math.max.apply(null, totals);
    const winnerIdx = totals.indexOf(maxScore);
    resultId = resultMap[winnerIdx];
  }

  $('.nombre-usuario').text(localStorage.getItem('name') || '');
  $('#' + resultId).addClass('active');
  } // end else (no forced item)
}

	// $('.next').click(function(e){
	// 	const name = $('#name').val();
	// 	const idade = $('input[name=idade].selected').val();
	// 	const sexo = $('input[name=sexo].selected').val();
	//
	// 	if($('#name').length) {
	// 		if($('#name').val() != "") {
	// 			localStorage.setItem('name', name);
	// 		} else {
	// 			e.preventDefault();
	// 			$('#name').addClass('invalid');
	// 		}
	// 	}
	// 	if($('input[name=idade]').length) {
	// 		if($('input[name=idade]').hasClass('selected')) {
	// 			localStorage.setItem('idade', idade);
	// 		} else {
	// 			e.preventDefault();
	// 			$('input[name=idade]').parent().addClass('invalid');
	// 		}
	// 	}
	//
	// 	if($('input[name=sexo]').length) {
	// 		if($('input[name=sexo]').hasClass('selected')) {
	// 			localStorage.setItem('sexo', sexo);
	// 		} else {
	// 			e.preventDefault();
	// 			$('input[name=sexo]').parent().addClass('invalid');
	// 		}
	// 	}
	//
	// });

});
